import React from 'react'

const Label = ({ labelTextColor, label, darkMode, name, required = false, err = false }) => {
    return (
        <label className={`mb-1 md:mb-5 ${darkMode ? "text-white" : `${labelTextColor ? labelTextColor : 'text-black'}`} ${err && "text-error"} font-bold`} htmlFor={name}>
            {label}&nbsp;{required && <span className='text-error'>*</span>}
        </label>
    )
}

export default Label